module.exports = __webpack_public_path__ + "img/pro_16.7a1b9274.jpg";